<template>
	<div>
		<div v-if="hasValidationErrors" class="alert alert-bad">
			<ul>
				<li v-for="error in errors" :key="`${ field }-${ error }`"><span class="fa fa-flag"></span>{{ error }}</li>
			</ul>
		</div>
		<file-upload-field v-model="value" :field="field" :module="module" :current="hasExistingFile ? `${value[field.slug + '_filepath']}${value[field.slug + '_filename']}` : ''"></file-upload-field>
	</div>
</template>

<script>

import CrudField from '@/mixins/CrudField';
import FileUploadField from './FileUploadField';

// TODO - Must make row editable
export default {

	mixins: [CrudField],

	computed: {
		hasExistingFile: function() {
			if (this.value && this.value[ this.field.slug + '_filename' ]) {
				return (this.value[ this.field.slug + '_filename' ] !== null && this.value[ this.field.slug + '_filename' ] !== '');
			}

			return false;
		},
	},

	components: { FileUploadField },

};
</script>
